const Required = ({ label = "", ...rest }) => {
  return (
    <div {...rest} className="inline-block" style={{ fontWeight: "bold" }}>
      {`*  ${label ? label : ""}`}
    </div>
  );
};

export default Required;
